<template>
  <div class="wrap">
    <div class="title" v-if="item.display_code !== 'benefitMoreimage'">
      {{ item.name }}
    </div>
    <div class="desc" v-if="item.display_code !== 'benefitMoreimage'">
      {{ item.desc }}
    </div>
    <div class="content" v-for="item of benefitList" :key="item.id">
      <van-image :src="item.display_img_url" :data-type="item.benefit_type" />
      <div class="content-btn" @click="handleDraw(item)">查看详情</div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useRouter } from "@/components/use/base";

export default defineComponent({
  name: "benefitMore",
  props: ["item", "card"],
  setup(props) {
    const router = useRouter();

    const benefitList = computed(() => {
      return props.item.productInfo;
    });

    const handleDraw = (item) => {
      router.push(`benefitDetail?benefit_type=${item.benefit_type}`);
    };

    return {
      benefitList,
      handleDraw,
    };
  },
});
</script>


<style lang="less" scoped>
.wrap {
  padding: 0 12px;
  margin-top: 0px;

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
    margin-top: 32px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }
}

.content {
  margin-top: 16px;
  display: block;
  position: relative;

  .content-btn {
    width: 70px;
    height: 24px;
    background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
    border-radius: 13px;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);

    font-weight: 500;
    font-size: 12px;
    color: #000000;
    line-height: 24px;
    text-align: center;
  }

  /deep/ .van-image {
    display: block;
    height: 122px;
    margin-top: 12px !important;
  }
}
</style>